import { fetchUser } from './fetchUser';
import type { AviosAuthUserSession } from './types';

// We cache the in-flight promise to prevent duplicate network requests
// if silentAuth is called multiple times simultaneously.
let inFlightAuthRequest: Promise<AviosAuthUserSession | null> | null = null;

/**
 * The public function consumed by AuthProvider.
 * Implements Promise deduping to ensure only one network request fires at a time.
 */
export async function silentAuth({
  sessionId,
  isLocalhost,
  gatewayUrl,
}: {
  sessionId?: string;
  isLocalhost?: boolean;
  gatewayUrl?: string;
}): Promise<AviosAuthUserSession | null> {
  // If a request is already happening, return that exact same promise
  if (inFlightAuthRequest) {
    return inFlightAuthRequest;
  }

  // Otherwise, start a new request and cache the promise
  inFlightAuthRequest = fetchUser({ sessionId, isLocalhost, gatewayUrl }).finally(() => {
    // Clear the cache once the request completes (success or fail)
    // so subsequent calls will fetch fresh data.
    inFlightAuthRequest = null;
  });

  return inFlightAuthRequest;
}
